// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hxHI","largestCol":"styles_largestCol__3Z6A5","smallestCol":"styles_smallestCol__1Ggss"};